import React from "react";

export interface TeamIcon {
  id: string;
  label: string;
  svg: string;
  bgColor: string;
  iconColor: string;
}

const TEAM_ICONS: TeamIcon[] = [
  {
    id: "lion",
    label: "Lion",
    bgColor: "#1a3a2a",
    iconColor: "#fbbf24",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 14H8v-1c0-2 4-3.1 4-3.1s4 1.1 4 3.1v1zm1-7.5c-.3.5-.8.8-1.3.9.2.3.3.7.3 1.1 0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2 0-.4.1-.8.3-1.1-.5-.1-1-.4-1.3-.9-.5-.8-.2-1.8.5-2.3l2-1.5c.3-.2.7-.2 1 0l1.5 1.1 1.5-1.1c.3-.2.7-.2 1 0l2 1.5c.7.5 1 1.5.5 2.3z" fill="currentColor"/>`,
  },
  {
    id: "tiger",
    label: "Tiger",
    bgColor: "#2a1a0a",
    iconColor: "#f97316",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 4l1-2 1 2h2l-1.5 1.5L14 9l-2-1-2 1 .5-1.5L9 6h2zm5 10c0 1-1 2-4 2s-4-1-4-2c0-.5.5-1 1-1.5-.5-.5-1-1-1-1.5 0-1 1-2 2-2h4c1 0 2 1 2 2 0 .5-.5 1-1 1.5.5.5 1 1 1 1.5zm-1-6c-.5 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1zm-6 0c-.5 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1z" fill="currentColor"/>`,
  },
  {
    id: "eagle",
    label: "Eagle",
    bgColor: "#1a2a3a",
    iconColor: "#60a5fa",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 2c1.5 0 2.5 1 3 2l-1 1h-4l-1-1c.5-1 1.5-2 3-2zm6 9l-2 5h-2l-1-3h-2l-1 3H8l-2-5 2-3c0-1 1-2 2-2h4c1 0 2 1 2 2l2 3zm-5-4c-.5 0-1 .5-1 1s.5 1 1 1 1-.5 1-1-.5-1-1-1zm-2 0c-.5 0-1 .5-1 1s.5 1 1 1 1-.5 1-1-.5-1-1-1z" fill="currentColor"/>`,
  },
  {
    id: "falcon",
    label: "Falcon",
    bgColor: "#1a1a2a",
    iconColor: "#a78bfa",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 7l-1 2-2-1v3l-2 4-2-4v-3l-2 1-1-2 3-2V5l2 2 2-2v2l3 2zm-6 5c0 .5.5 1 1 1s1-.5 1-1-.5-1-1-1-1 .5-1 1z" fill="currentColor"/>`,
  },
  {
    id: "wolf",
    label: "Wolf",
    bgColor: "#1a2020",
    iconColor: "#94a3b8",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-3 4l2 3h2l2-3 2 4-1 2c0 1-1 2-2 2v2c0 1-1 2-2 2s-2-1-2-2v-2c-1 0-2-1-2-2l-1-2 2-4zm2 5c-.5 0-1 .5-1 1s.5 1 1 1 1-.5 1-1-.5-1-1-1zm4 0c-.5 0-1 .5-1 1s.5 1 1 1 1-.5 1-1-.5-1-1-1z" fill="currentColor"/>`,
  },
  {
    id: "panther",
    label: "Panther",
    bgColor: "#0a0a1a",
    iconColor: "#c084fc",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 6c.5 0 1 .5 1 1s-.5 1-1 1-1-.5-1-1 .5-1 1-1zm-8 0c.5 0 1 .5 1 1s-.5 1-1 1-1-.5-1-1 .5-1 1-1zm4 12c-2.5 0-4-1.5-4-3h2c0 .5.5 1 2 1s2-.5 2-1h2c0 1.5-1.5 3-4 3zm3-5H9c-1 0-1.5-1-1-2l1-2h6l1 2c.5 1 0 2-1 2z" fill="currentColor"/>`,
  },
  {
    id: "shark",
    label: "Shark",
    bgColor: "#0a1a2a",
    iconColor: "#38bdf8",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6 10l-3 2-1 4-2-2-2 2-1-4-3-2 3-2 1-4 2 2 2-2 1 4 3 2zm-7-1c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z" fill="currentColor"/>`,
  },
  {
    id: "dragon",
    label: "Dragon",
    bgColor: "#2a0a0a",
    iconColor: "#ef4444",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 5l-1 3 2 1-3 2v3l-2-1-2 1v-3l-3-2 2-1-1-3 3 1 1-2 1 2 3-1zm-5 5c0 .5.5 1 1 1s1-.5 1-1-.5-1-1-1-1 .5-1 1z" fill="currentColor"/>`,
  },
  {
    id: "knight",
    label: "Knight",
    bgColor: "#1a1a0a",
    iconColor: "#eab308",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 4h2l1 2v2h1v2h-1l1 3v2c0 1-1 2-2 2h-2c-1 0-2-1-2-2v-2l1-3H9v-2h1V8l1-2zm0 4v2h2v-2h-2z" fill="currentColor"/>`,
  },
  {
    id: "shield",
    label: "Shield",
    bgColor: "#0a2a1a",
    iconColor: "#10b981",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3l5 2v4c0 3.5-2.1 6.5-5 7.5-2.9-1-5-4-5-7.5V7l5-2zm0 2.5L9 9v3c0 2 1.2 4 3 4.8 1.8-.8 3-2.8 3-4.8V9l-3-1.5z" fill="currentColor"/>`,
  },
  {
    id: "crown",
    label: "Crown",
    bgColor: "#2a1a00",
    iconColor: "#fbbf24",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 12H7v-2l2-3-1-3 4 2 4-2-1 3 2 3v2zm-5-6c.5 0 1 .5 1 1s-.5 1-1 1-1-.5-1-1 .5-1 1-1z" fill="currentColor"/>`,
  },
  {
    id: "bat",
    label: "Cricket Bat",
    bgColor: "#1a2a1a",
    iconColor: "#4ade80",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 13.5l-1.5 1.5-1-1-4-4c-.5-.5-.5-1.5 0-2l3-3c.5-.5 1.5-.5 2 0l4 4 .5.5-1.5 1.5-1.5-1.5-1 1z" fill="currentColor"/>`,
  },
  {
    id: "ball",
    label: "Cricket Ball",
    bgColor: "#2a0a0a",
    iconColor: "#f87171",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-3-9c0-.5.2-1 .5-1.5m5 0c.3.5.5 1 .5 1.5m-6 2c0 1.5 1 3 2.5 3.5m3 0c1.5-.5 2.5-2 2.5-3.5" fill="none" stroke="currentColor" stroke-width="1.5"/>
    <circle cx="12" cy="12" r="4" fill="currentColor" opacity="0.3"/>
    <circle cx="12" cy="12" r="2" fill="currentColor"/>`,
  },
  {
    id: "stumps",
    label: "Stumps",
    bgColor: "#1a1a00",
    iconColor: "#fcd34d",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 5h1v8h-1V7zm2 0h1v8h-1V7zm2 0h1v8h-1V7zm-5 9h7v1H9v-1zm1-10h5v1h-5V6z" fill="currentColor"/>`,
  },
  {
    id: "star",
    label: "Star",
    bgColor: "#1a2a2a",
    iconColor: "#22d3ee",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4l1.5 3.5H17l-2.8 2 1 3.5L12 13l-3.2 2 1-3.5L7 9.5h3.5L12 6z" fill="currentColor"/>`,
  },
  {
    id: "bolt",
    label: "Thunder",
    bgColor: "#1a1a2a",
    iconColor: "#fbbf24",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 4l-3 6h2l-1 6 5-7h-3l2-5h-2z" fill="currentColor"/>`,
  },
  {
    id: "flame",
    label: "Flame",
    bgColor: "#2a0a00",
    iconColor: "#fb923c",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c0 2-1 3-1 5s1 3 3 3c-1 2-3 3-4 3-2 0-3-2-3-4 0-3 2-5 3-6 0 1 1 1 1 0 0-1 1-1 1-1z" fill="currentColor"/>`,
  },
  {
    id: "arrow",
    label: "Arrow",
    bgColor: "#0a1a0a",
    iconColor: "#34d399",
    svg: `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4l5 5h-3v5h-4v-5H7l5-5z" fill="currentColor"/>`,
  },
];

export function getTeamIconById(id: string): TeamIcon | undefined {
  return TEAM_ICONS.find((icon) => icon.id === id);
}

export function getRandomIcon(): TeamIcon {
  return TEAM_ICONS[Math.floor(Math.random() * TEAM_ICONS.length)];
}

interface TeamIconPickerProps {
  selectedIconId: string | null;
  onSelect: (icon: TeamIcon) => void;
  onShuffle: () => void;
}

export default function TeamIconPicker({ selectedIconId, onSelect, onShuffle }: TeamIconPickerProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold text-white">Choose Team Icon</span>
        <button
          type="button"
          onClick={onShuffle}
          className="flex items-center gap-1.5 text-xs text-emerald-400 hover:text-emerald-300 font-medium transition-colors px-2 py-1 rounded-lg hover:bg-emerald-900/20"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Shuffle
        </button>
      </div>
      <div className="grid grid-cols-6 gap-2">
        {TEAM_ICONS.map((icon) => (
          <button
            key={icon.id}
            type="button"
            onClick={() => onSelect(icon)}
            className={`relative w-full aspect-square rounded-xl flex items-center justify-center transition-all ${
              selectedIconId === icon.id
                ? "ring-2 ring-emerald-400 scale-110 z-10"
                : "hover:scale-105 hover:ring-1 hover:ring-white/20"
            }`}
            style={{ backgroundColor: icon.bgColor }}
            title={icon.label}
          >
            <svg
              className="w-6 h-6"
              viewBox="0 0 24 24"
              style={{ color: icon.iconColor }}
              dangerouslySetInnerHTML={{ __html: icon.svg }}
            />
            {selectedIconId === icon.id && (
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full flex items-center justify-center">
                <svg className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export function TeamIconPreview({ icon, size = "md" }: { icon: TeamIcon; size?: "sm" | "md" | "lg" }) {
  const sizeClasses = size === "sm" ? "w-8 h-8" : size === "lg" ? "w-14 h-14" : "w-10 h-10";
  const iconSize = size === "sm" ? "w-4 h-4" : size === "lg" ? "w-8 h-8" : "w-5 h-5";

  return (
    <div
      className={`${sizeClasses} rounded-full flex items-center justify-center border border-white/10`}
      style={{ backgroundColor: icon.bgColor }}
    >
      <svg
        className={iconSize}
        viewBox="0 0 24 24"
        style={{ color: icon.iconColor }}
        dangerouslySetInnerHTML={{ __html: icon.svg }}
      />
    </div>
  );
}

export { TEAM_ICONS };
